import agent from 'superagent';
import * as help from 'helpers';

export const API_ROOT = window.yconfig.ApiUrl;

const responseBody = async (res) => {
    if (res.body && res.body.resultCode === 'RedirectShopper') {
        await help.route_secure_payment(res.body, res.req);
    }

    return res.body;
};

// X-Application-Name is set to AccountSite to help backend figure out if a route is called by either the app or the website, this is used in analytics
const setApplicationNameHeader = (request) => {
    if (request && request.header) {
        request.header['X-Application-Name'] = 'AccountSite';
    }
};
const requestMiddlewares = (req) => {
    setApplicationNameHeader(req);
    req.withCredentials();
};

const Agent = {
    del: (url) => {
        return agent
            .del(`${API_ROOT}${url}`)
            .use(requestMiddlewares)
            .then(responseBody);
    },
    get: (url, middleware = null) => {
        let request = agent.get(`${API_ROOT}${url}`).use(requestMiddlewares);

        if (middleware) {
            request = request.use(middleware);
        }

        return request.then(responseBody);
    },
    put: (url, body) => {
        return agent
            .put(`${API_ROOT}${url}`, body)
            .use(requestMiddlewares)
            .then(responseBody);
    },
    post: (url, body, middleware = null) => {
        let request = agent
            .post(`${API_ROOT}${url}`, body)
            .use(requestMiddlewares);

        if (middleware) {
            request = request.use(middleware);
        }
        return request.then(responseBody);
    },
    upload: (url, avatar, body) => {
        return agent
            .post(`${API_ROOT}${url}`, body)
            .use(requestMiddlewares)
            .attach('profile_picture', avatar)
            .then(responseBody);
    },
    postJson: (url, body) => {
        return agent
            .post(`${API_ROOT}${url}`)
            .send(body)
            .use(requestMiddlewares)
            .then(responseBody);
    },
};

export default Agent;
